function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import Icon from '../Icon/Icon';
import { ReactComponent as Svg } from '../../../icons/QuestionMark/QuestionMark.svg';
export default function QuestionMark(_ref) {
  var className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    attrs = _objectWithoutProperties(_ref, ["className", "width", "height"]);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    className: className,
    width: width,
    height: height,
    icon: Svg,
    legacy: true
  }, attrs));
}